import { apiDelete } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function deleteService(id: string | number) {
  const result = await apiDelete(`service/${id}`);
  if (result.resultCategory == 1) {
    usePortcallStore().removeServiceItem(id);
  }
}
